// extracted by mini-css-extract-plugin
export var fadeInOut = "_3e-3";
export var icon = "_3e-4";
export var savedIndicator = "_3e-2";
export var savingIndicator = "_3e-0";
export var spin = "_3e-1";